export const TOKEN_ADDRESSES = {
    TESTNET: {
        tastManager: "0x09a6935f1c6B237E1389ff83Bd5c5897CD1aDf4B",
        task: '0x60E12dCa329601a1B5e9A90b236021fFFf345bA8',
        busd: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
        tomi: "0x84f0bc91f23649c76139d402a1c00c6ac19a4400",
        eth: "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
        usdc: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
        wbtc: "0x54410d42628C7fD6720C489219033345Bcb7Cc73",
        link: "0x37bBd68526C9BDb49f18fB36983701E344f2A163",
        pepe: "0x0592EBa69Aa5f2eF68d9cb740fBaB2c0c0CC6A91",
        unisape: "0x079c46A5Ba477400a326E03Ad8D22FaBeaE57b4F",
        gems: "0xB297D4b01b286de35Ee12cdCe89Ec9488EEec0C2",
        dop: "0xa048E46C35cf210bB0d5bb46b2DD06828Ef17893",
        //createTask Tokens
        ETH: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        USDT: '0x6fEA2f1b82aFC40030520a6C49B0d3b652A65915',
        USDC: '0x25762231808F040410586504fDF08Df259A2163c',
        orc: '0xe3dB2f52eeC0Fb7B287Ddde4172Ba1cac4Ba9330',

        trxHashUrl: 'https://sepolia.etherscan.io',
        trxHashUrl_Arb: 'https://sepolia.etherscan.io',
        miniDispute: '0x3b19685d5fd4ccd36c17c67f7017581463fb2904',
        regularDispute: '0x81cc8860e21b6cb8d73709aab1ff34de131bebe1',

        siteURL: 'https://stg-tasks.quecko.org',
        // IPFS_URI: 'https://salmon-dirty-spider-776.mypinata.cloud/ipfs/'
        IPFS_URI: 'https://gateway.pinata.cloud/ipfs/'
        
    },
    MAINNET: {
        tastManager: "0xB9DD1A392334444E2c7e14018BA3cd64D002Fb18",
        task: '0x9012699632f0Dc507D1B578EE1b911019Ae1b94d',
        ORC: '0xf3EEC6BD2934E7c365912C7697876a0dCa8C52c9',
        busd: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
        // tomi: "0x4385328cc4d643ca98dfea734360c0f596c83449",
        eth: "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
        usdc: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
        wbtc: "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
        link: "0xf97f4df75117a78c1A5a0DBb814Af92458539FB4",
        pepe: "0x25d887Ce7a35172C62FeBFD67a1856F20FaEbB00",
        unisape: "0xFa7F8980b0f1E64A2062791cc3b0871572f1F7f0",
        // gems: "0x3010ccb5419f1ef26d40a7cd3f0d707a0fa127dc",
        // dop: "0x97a9a15168c22b3c137e6381037e1499c8ad0978",
        //createTask Tokens
        ETH: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
        USDT: '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9',
        USDC: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
        trxHashUrl: 'https://etherscan.io',
        trxHashUrl_Arb: 'https://arbiscan.io',
        miniDispute: '0x5C2A50Cd4D244588e8536956CdE1675d7b7e0976',
        regularDispute: '0x9b78d4C7CFaF34059f5a5fE782Ac7991a14C7971',
        siteURL: 'https://tasks.market',
        IPFS_URI: 'https://salmon-dirty-spider-776.mypinata.cloud/ipfs/'
    }
}